import React from 'react';
import styled, { css } from 'styled-components';

// #72 (UI düzeltme demeti T6) — T2'nin (`pages/evaluation-periods/
// PeriodWizard.js`) `NavIconBtn`/`PrevIconBtn`/`NextIconBtn` ailesinin
// GENELLEŞTİRİLMİŞ hâli: "düşük riskli" yerlerde (modal kapat, satır
// aksiyonları, navigasyon okları) devasa dikdörtgen butonlar yerine kompakt,
// dairesel ikon butonu + uygulamanın `Tooltip`'i (kullanıcı talimatı,
// birebir) kombinasyonu.
//
// Tooltip SARMALAMA burada YAPILMAZ — çağıran taraf `Tooltip` (components/ui
// /Tooltip.js) ile sarmalar (PeriodWizard.js'in kendi deseni, bkz.
// t2-report.md §2.3): `<Tooltip text={t(...)}><IconButton>...</IconButton>
// </Tooltip>`. Bu, tooltip'siz kullanımı da (ör. zaten görünür bir etiketin
// yanında duran bir ikon aksiyonu) mümkün kalır.
//
// `variant`: "neutral" (varsayılan, T2'nin `PrevIconBtn`'i — nötr/bordürlü,
// geri/ikincil aksiyonlar), "gradient" (T2'nin `NextIconBtn`'i — uygulamanın
// yerleşik gradyan kimliği, SidebarMenu.js'in SearchAction'ıyla AYNI tarif,
// ileri/birincil aksiyonlar), "danger" (yıkıcı aksiyonlar — repo genelinde
// tekrarlanan "nötr + hover'da kırmızı" satır-silme ikonu deseninin merkezi
// hâli, ör. RatingScalesTab.js/GoalTemplatesTab.js'in RemoveIconBtn'i).
const variants = {
  neutral: css`
    border: 1.5px solid #E0E4E8;
    background: #fff;
    color: ${({ theme }) => theme.colors.text.dark.little};

    &:hover:not(:disabled) {
      border-color: ${({ theme }) => theme.colors.primary.main};
      color: ${({ theme }) => theme.colors.primary.main};
      background: rgba(2, 145, 239, 0.06);
    }
    &:disabled { opacity: 0.4; }
  `,
  gradient: css`
    border: none;
    color: #fff;
    background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary.main}, ${({ theme }) => theme.colors.secondary.main});
    box-shadow: 0 2px 8px rgba(2, 145, 239, 0.28);

    &:hover:not(:disabled) { box-shadow: 0 4px 14px rgba(2, 145, 239, 0.38); }
    &:disabled {
      background: #E0E4E8;
      color: #A0A8B4;
      box-shadow: none;
    }
  `,
  danger: css`
    border: 1.5px solid #E0E4E8;
    background: #fff;
    color: ${({ theme }) => theme.colors.text.dark.little};

    &:hover:not(:disabled) {
      border-color: ${({ theme }) => theme.colors.auxiliar.danger};
      color: ${({ theme }) => theme.colors.auxiliar.danger};
      background: rgba(229, 57, 53, 0.06);
    }
    &:disabled { opacity: 0.4; }
  `,
};

const SIZES = { sm: 32, md: 40 };

const StyledIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => SIZES[$size] || SIZES.md}px;
  height: ${({ $size }) => SIZES[$size] || SIZES.md}px;
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;

  @media (prefers-reduced-motion: no-preference) {
    transition: box-shadow 0.15s ease, border-color 0.15s ease, color 0.15s ease, background 0.15s ease, opacity 0.15s ease;
  }

  ${({ $variant }) => variants[$variant] || variants.neutral}

  &:disabled { cursor: not-allowed; }
`;

export default function IconButton({ children, variant = 'neutral', size = 'md', ...props }) {
  return (
    <StyledIconButton $variant={variant} $size={size} {...props}>
      {children}
    </StyledIconButton>
  );
}
